import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { PAGES, PRODUCT_DETAIL_URL, titles } from '@om/redux/actions/sizotsaFuneralCover/types';
import {
    OmApplicationCoverCategories,
    OmApplicationCoverCategoryCard,
    OmButton,
    OmCheckBox,
    OmEfpFamilyMemberCardGroup,
    OmEfpQuotePage,
    OmIcon,
    OmModalLoader,
   
} from '@om/component-library-react';
import BwQuoteSummaryCard from './BwQuoteSummaryCard';
import './SizotsaFuneralQuotePage.scss';
import { SF_COVER_CATEGORIES } from '@om/redux/actions/sizotsaFuneralCover/types';
import {
    editQuote,
    removeMember,
    setQuoteDetailsStateValue,
    setQuoteDrawerValue,
    synchFormValue,
} from '@om/redux/actions/sizotsaFuneralCover/quote';
import { getIsOnInitPage, getLivesCovered, getMaxMembersCountReached } from '@om/redux/selectors/sizotsaFuneralCover/quote';
import { createStructuredSelector } from 'reselect';
import QuoteModals from '../quoteModals/QuoteModals';
import SizotsaFamilyMemberCard from './SizotsaFamilyMemberCard';
import BenefitsCard from './BenefitsCard';
import { getQuoteRequest } from '@om/redux/actions/sizotsaFuneralCover/policyRequest';
import { getApiDetails } from '@om/redux/selectors/sizotsaFuneralCover/referenceData';
import { API_CALL_STATUS } from '@om/redux/reducers/status';
import ErrorModal from '../quoteModals/ErrorModal';
import { navigate } from 'gatsby';
import { setSizotsaApiDetails } from '@om/redux/actions/sizotsaFuneralCover/referenceData';

const InitCoverView = () => {
    const dispatch = useDispatch();

    return (
        <div className="is-init-page">
            <div class="center">
                <h4 className='no-bottom-margin'>Get a quote and <strong>buy online now!</strong></h4>
                <p>Choose who you would like to cover and see how much it will cost.</p>
                <p className='center large-margin-top'><strong>Did you know?</strong> You can cover up to 20 loved ones, including parents and extended family members.</p>
            </div>
            <OmApplicationCoverCategories>
                <OmApplicationCoverCategoryCard slot="first">
                    <OmIcon
                        slot="icon"
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt0f93690bb13df2a7/5f61ddd6046a1b546bb1592a/direct-family-gradient.svg"
                    />
                    <span slot="title">Myself</span>
                    <div slot='description' style={{height:'130px',marginTop:'1rem'}}  ><strong>Myself</strong> - This package allows you to cover Yourself . You can also  add your Parents or Extended Family</div>
                    <span slot="button">
                        <OmButton
                            text="Select Cover"
                            type="secondary"
                            size="small"
                            onClick={() => {
                                dispatch(
                                    setQuoteDrawerValue({ fieldType: 'coverType', value: SF_COVER_CATEGORIES.MYSELF })
                                );
                            }}
                        />
                    </span>
                </OmApplicationCoverCategoryCard>

                <OmApplicationCoverCategoryCard slot="second">
                    <OmIcon
                        slot="icon"
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blteaa4e52be1a62cee/5f61ddd625f7a73d06685672/extended-family-gradient.svg"
                    />
                    <span slot="title">Me and My Direct Family</span>
                    <div style={{height:'130px',marginTop:'1rem'}} slot='description'><strong>Me & My Direct Family</strong> - This package allows you to cover Yourself, Spouse/Partner and Children. You can also add your Parents or Extended Family</div>
                    <span slot="button">
                        <OmButton
                            text="Select Cover"
                            type="secondary"
                            size="small"
                            onClick={() => {
                                dispatch(
                                    setQuoteDrawerValue({ fieldType: 'coverType', value: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY })
                                );
                            }}
                        />
                    </span>
                </OmApplicationCoverCategoryCard>

                {/* <OmApplicationCoverCategoryCard slot="third">
                    <OmIcon
                        slot="icon"
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/bltc0d8ac0985724060/5f61ddd6ea082953944f735d/parents-and-inlaws-gradient.svg"
                    />
                    <span slot="title">
                        My Extended Family
                    </span>
                    <span slot="button">
                        <OmButton
                            text="Select Cover"
                            type="secondary"
                            size="small"
                            onClick={() => openExtendedFamilySideDrawer()}
                        />
                    </span>
                </OmApplicationCoverCategoryCard> */}
            </OmApplicationCoverCategories>

            
        </div>
    );
};

const MoreCoverView = () => {
    const dispatch = useDispatch();
    const {
        livesCovered,
        maxMembersCountReached
        // quotePageCoverList,
        // benefitsModal,
        // benefitsDetails,
        // benefitsDetailsOnPremium,
    } = useSelector(
        createStructuredSelector({
            livesCovered: getLivesCovered,
            maxMembersCountReached:getMaxMembersCountReached,
            // quotePageCoverList: getQuotePageCoverList,
            // benefitsModal:getBenefitsModal,
            // benefitsDetails: getBenefitsDetails,
            // benefitsDetailsOnPremium:getBenefitsDetailsOnPremium
        })
    );    
    const {
        [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: meAndMyDirectfamily,
        [SF_COVER_CATEGORIES.EXTENDED_FAMILY]: extendedFamily,
        [SF_COVER_CATEGORIES.BENIFITS]: benefits,
        [SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS]: parentsinLaws,
    } = livesCovered;
    // const openLivesCoveredSideDrawer = () => {
    //     if (addedMaxCoverMembers) {
    //         return;
    //     }

    //     dispatch(setNewCoverDefault());
    //     dispatch(setSideDrawerOpen(EFP_ADD_COVER_DRAWERS.LIVES_COVERED));
    // };

    // const openBenifitsSideDrawer = () => {
    //     dispatch(setSideDrawerOpen(EFP_ADD_COVER_DRAWERS.BENEFITS));
    // };
    return (
        <div>
            <div className="is-not-init-page">
                <div className="family-member-card-group-wrapper sizostaQoute">
                    <div className="quote-heading-wrapper">
                        <h4 className="light no-top-margin">Here's how much it will cost</h4>
                    </div>

                    <OmEfpFamilyMemberCardGroup
                        headingText={
                            titles[
                                Object.values(meAndMyDirectfamily)?.length === 1 ? 'Myself' : 'Me_and_My_Direct_Family'
                            ]
                        }
                    >
                        <div slot="family-member-card-items">
                            <SizotsaFamilyMemberCard
                                key={'MnD'}
                                id={'Myslef'}
                                relationship={
                                    Object.values(meAndMyDirectfamily)?.length > 1 ? 'Me & My Family' : 'Myself'
                                }
                                age={Object.values(meAndMyDirectfamily)[0]?.age.value   ?? '-'}
                                coverAmount={Object.values(meAndMyDirectfamily)[0]?.coverAmount.value ?? '-'}
                                monthlyPremium={Object.values(meAndMyDirectfamily)[0]?.monthlyPremium.value}
                                category={SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY}
                                incomeStabilization={Object.values(meAndMyDirectfamily)[0]?.needIncomeStabilization.value==='Yes'?Object.values(meAndMyDirectfamily)[0]?.incomeStabilization.value:null}
                                onDelete={() => {
                                    dispatch(
                                        removeMember({
                                            id: Object.keys(meAndMyDirectfamily)[0],
                                            category: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                        })
                                    );
                                }}
                                onEdit={() =>
                                    dispatch(
                                        editQuote({
                                            id: Object.keys(meAndMyDirectfamily)[0],
                                            category: SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY,
                                            coverType:
                                                Object.values(meAndMyDirectfamily)?.length > 1
                                                    ? SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
                                                    : SF_COVER_CATEGORIES.MYSELF,
                                        })
                                    )
                                }
                            />
                        </div>
                    </OmEfpFamilyMemberCardGroup>
                   {Object.keys(parentsinLaws).length>0&& <OmEfpFamilyMemberCardGroup headingText={titles.My_Parents_and_In_laws}>
                        <div slot="family-member-card-items">
                            {Object.keys(parentsinLaws)?.map((relation, keyIndex) => {
                                const { age, coverAmount, monthlyPremium ,relationship} = parentsinLaws[relation];
                                return (
                                    <SizotsaFamilyMemberCard
                                        key={keyIndex}
                                        id={relation}
                                        relationship={relationship.value}
                                        age={age.value ?? '-'}
                                        deleteEnabled
                                        coverAmount={coverAmount.value ?? '-'}
                                        monthlyPremium={monthlyPremium.value}
                                        category={SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS}
                                        // onDelete={() => dispatch(removeMember({ id: relation, category }))}
                                        onDelete={() =>
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'deleteQuoteDetails',
                                                    value: {
                                                        id: relation,
                                                        category: SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                                                        message: `Are you sure you want to remove ${
                                                            relation?.split('_')[0]
                                                        }?`,
                                                    },
                                                })
                                            )
                                        }
                                        onEdit={() =>
                                            dispatch(
                                                editQuote({
                                                    id: relation,
                                                    category: SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                                                    coverType: SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                                })
                                            )
                                        }
                                    />
                                );
                            })}
                        </div>
                    </OmEfpFamilyMemberCardGroup>}
                   {Object.keys(extendedFamily).length>0&& <OmEfpFamilyMemberCardGroup headingText={titles.My_Extended_Family}>
                        <div slot="family-member-card-items">
                            {Object.keys(extendedFamily)?.map((relation, keyIndex) => {
                                const { age, coverAmount, monthlyPremium ,relationship} = extendedFamily[relation];
                                return (
                                    <SizotsaFamilyMemberCard
                                        key={keyIndex}
                                        id={relation}
                                        relationship={relationship.value}
                                        age={age.value  ?? '-'}
                                        deleteEnabled
                                        coverAmount={coverAmount.value ?? '-'}
                                        monthlyPremium={monthlyPremium.value}
                                        category={SF_COVER_CATEGORIES.EXTENDED_FAMILY}
                                        // onDelete={() => dispatch(removeMember({ id: relation, category }))}
                                        onDelete={() =>
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'deleteQuoteDetails',
                                                    value: {
                                                        id: relation,
                                                        category: SF_COVER_CATEGORIES.EXTENDED_FAMILY,
                                                        message: `Are you sure you want to remove ${
                                                            relation?.split('_')[0]
                                                        }?`,
                                                    },
                                                })
                                            )
                                        }
                                        onEdit={() =>
                                            dispatch(
                                                editQuote({
                                                    id: relation,
                                                    category: SF_COVER_CATEGORIES.EXTENDED_FAMILY,
                                                    coverType: SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                                })
                                            )
                                        }
                                    />
                                );
                            })}
                        </div>
                    </OmEfpFamilyMemberCardGroup>}
                   
            
                </div>
            </div>

          { !maxMembersCountReached && <div className="add-more-cover-wrapper">
                <h5 className="medium">Would you like to cover more people?</h5>
                <div className="button-wrapper">
                    <OmButton
                        text="ADD MEMBER +"
                        type="secondary"
                        size="small"
                        // actionType={addedMaxCoverMembers}
                        onClick={() => {
                            dispatch(
                                setQuoteDrawerValue({
                                    fieldType: 'coverType',
                                    value: SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                })
                            );
                        }}
                    />
                </div>
            </div>}
            <div className="family-member-card-group-wrapper">
            {Object.keys(benefits).length>0&& <OmEfpFamilyMemberCardGroup headingText={'You\'ve added these benefits'}>
                        <div slot="family-member-card-items">
                                    <BenefitsCard
                                        key={'benefits'}
                                        id={'benefits'}
                                        deleteEnabled
                                        coverAmount={Object.values(benefits)[0]?.incomeStabilization?.value}
                                        monthlyPremium={Object.values(benefits)[0]?.monthlyPremium?.value}
                                        premiumPaidUp={Object.values(benefits)[0]?.benefitsDetailsOnPremium?.value}
                                        cashback={Object.values(benefits)[0]?.benefitsDetails?.value}
                                      
                                        onDelete={() =>
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'deleteQuoteDetails',
                                                    value: {
                                                        id: Object.keys(benefits)[0],
                                                        category: SF_COVER_CATEGORIES.BENIFITS,
                                                        message: `Are you sure you want to remove benefits?`,
                                                    },
                                                })
                                            )
                                        }
                                        onEdit={() =>
                                            dispatch(
                                                editQuote({
                                                    id: Object.keys(benefits)[0],
                                                    category: SF_COVER_CATEGORIES.BENIFITS,
                                                    coverType: SF_COVER_CATEGORIES.BENIFITS,
                                                })
                                            )
                                        }
                                    />
                        </div>
                    </OmEfpFamilyMemberCardGroup>}
                    </div>
          {/* {Object.values(livesCovered[SF_COVER_CATEGORIES.BENIFITS]).length===0 && <div className="add-more-cover-wrapper FuneralBenefitSummary">
                <h5 className="medium"> Would you like to add more benefits to your cover?</h5>
                <div className="button-wrapper">
                    <OmButton
                        text="Add benefits +"
                        type="secondary"
                        size="small"
                        // actionType={addedMaxCoverMembers}
                        onClick={() => {
                            dispatch(synchFormValue(SF_COVER_CATEGORIES.BENIFITS));
                            dispatch(
                                setQuoteDrawerValue({
                                    fieldType: 'coverType',
                                    value: SF_COVER_CATEGORIES.BENIFITS,
                                })
                            );
                        }}
                    />
                </div>
            </div>} */}
        </div>
    );
};

const SizotsaFuneralQuotePage = ({ slot }) => {
    const dispatch = useDispatch();
    const {isOnInitPage,
         livesCovered,
         apiDetails
         } = useSelector(
        createStructuredSelector({
            livesCovered:getLivesCovered,
            isOnInitPage: getIsOnInitPage,
            apiDetails:getApiDetails
        })
    );
    const [tooglePrivacyNotice, setTooglePrivacyNotice] = useState(false);
    
    useEffect(() => {
        if (Object.values(livesCovered).length>0 && !isOnInitPage) {     
            dispatch(getQuoteRequest());     
        }
    }, [livesCovered, dispatch]);

    // useSessionCamVariables(requestId);
    return (
        <>
            <OmEfpQuotePage slot={slot} className={'efp-quote-page'}>
                <div slot="side-drawers">
                    <QuoteModals />
                </div>
            
                <div slot="quote-page">
                    {isOnInitPage ? <InitCoverView /> : <MoreCoverView />}
                    <OmModalLoader verticalAlignMiddle loaderText={apiDetails?.name==="agentCodeService" ? "Fetching Agent Details..." : "Submitting your quote"   }  
                                open={apiDetails.status===API_CALL_STATUS.PENDING}
 />
                    <ErrorModal open={apiDetails.status===API_CALL_STATUS.FAILURE}content={apiDetails.content} onButtonClick={()=>dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.IDLE,name:null,content:null}))
                    }/>
                </div>
                <div slot="quote-summary-card" className='greyCheckbox'>
                    {!isOnInitPage &&(<div
                        className="check-box-container"
                        id="declarationquote"
                        style={{ textAlign: 'center', marginTop: '2rem' }}
                    >
                        <h5 className="medium">Before proceeding, please accept the terms & conditions and privacy policy.</h5>
                        <OmCheckBox
                            checked={tooglePrivacyNotice}
                            onOnCheckBoxChanged={() => setTooglePrivacyNotice((val) => !val)}
                        >
                            <p slot="text-slot">
                                I accept Old Mutual's&nbsp;
                                <a
                                    href="/disclaimer"
                                    style={{ color: '#282828', textDecoration: 'underline', fontWeight: 'normal' }}
                                    target="_blank"
                                >
                                    terms and conditions  
                                </a>
                                &nbsp; and I have read the &nbsp; 
                                <a
                                    href="/privacy-notice"
                                    style={{ color: '#282828', textDecoration: 'underline', fontWeight: 'normal' }}
                                    target="_blank"
                                >
                                    privacy notice 
                                </a>
                            </p>
                        </OmCheckBox>
                        
                    </div>)}
                </div>
                <div slot="quote-summary-card">
                    <div>{!isOnInitPage && <BwQuoteSummaryCard name="quote-card" isBuyNowDisabled={tooglePrivacyNotice}/>}</div>
                </div>
                <div slot="quote-summary-card-sticky">
                    <div>{!isOnInitPage && <BwQuoteSummaryCard isSticky name="quote-card-sticky" isBuyNowDisabled={tooglePrivacyNotice}/>}</div>
                </div>
               
            </OmEfpQuotePage>
           
            <div className="center large-margin-top">
                <p className="no-margin">
                    <strong>Please note, when adding a child:</strong>
                </p>
                <p className="no-margin">
                    Age limit: 21 years, unless the child is a student
                    <br />
                    If the child is a student, they can be covered until the age of 25
                    <br />
                    Special needs children are covered until the policy terminates, regardless of age <br />
                    Alternatively, you can add the child an extended family member
                </p>
            </div>
        </>
    );
};

export default SizotsaFuneralQuotePage;
